
const emptyButtonStyle = {
  padding: '2px',
  margin: '0px',
  background: 'none',
  color: 'unset',
  cursor: 'pointer',
  borderImage: 'unset',
  borderColor: 'unset',
  borderStyle: 'none',
};

export { emptyButtonStyle };
